import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import OrderInfo from '@/components/order/OrderInfo'
import AssistantGroup from '@/components/assistant/AssistantGroup'
import OrderDetails from '@/components/order/OrderDetails'
import OrderFans from '@/components/order/OrderFans'
import OrderUserLogin from '@/components/order/OrderUserLogin'
import UserRecharge from '@/components/user/UserRecharge'
import UserRechargePage from '@/components/user/UserRechargePage'
import OrderShareDetails from '@/components/order/OrderShareDetails'
import OrderShareFans from '@/components/order/OrderShareFans'
import OrderDetailsLog from '@/components/order/OrderDetailsLog'
import ShortLink from '@/components/shortLink/ShortLink'
import HomeIndex from '@/components/HomeIndex'
import empty from '@/components/empty'
import paySuccess from '@/components/paySuccess'
import payError from '@/components/payError'
Vue.use(Router)

const createRouter = () => new Router({
	mode: 'hash', // require service support
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRoutes
  })

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      hidden: true
    }, {
      path: '/home',
      name: '主页',
      component: Home,
      hidden: true,
      meta: {
        requireAuth: true
      },
	  children:[
		{
		  	path:"/assistant/Group",
		  	component:AssistantGroup,
		  	name:"聊天助手",
		  	meta:{"keepAlive":false,"requireAuth":true},
		},{
			path:"/order/info",
			component:OrderInfo,
			name:"工单管理",
			meta:{"keepAlive":false,"requireAuth":true},
		},{
			path:"/order/details",
			component:OrderDetails,
			name:"工单明细",
			meta:{"keepAlive":false,"requireAuth":true},
		},{
			path:"/order/fans",
			component:OrderFans,
			name:"粉丝明细",
			meta:{"keepAlive":false,"requireAuth":true},
		},{
			path:"/order/userLogin",
			component:OrderUserLogin,
			name:"登录日志",
			meta:{"keepAlive":false,"requireAuth":true},
		},{
			path:"/user/Recharge",
			component:UserRecharge,
			name:"充值记录",
			meta:{"keepAlive":false,"requireAuth":true},
		},{
			path:"/home/index",
			component:HomeIndex,
			name:"首页",
			meta:{"keepAlive":false,"requireAuth":true},
		},{
			path:"/user/rechargePage",
			component:UserRechargePage,
			name:"在线充值",
			meta:{"keepAlive":false,"requireAuth":true},
		},{
			path:"/order/detailsLog",
			component:OrderDetailsLog,
			name:"明细记录",
			meta:{"keepAlive":false,"requireAuth":true},
		},{
        path:"/short/link",
        component:ShortLink,
        name:"分流链接管理",
        meta:{"keepAlive":false,"requireAuth":true},
      }
	  ]
	}, {
      path: '/order/ShareDetails',
      name: '分享工单',
      component: OrderShareDetails,
      hidden: true,
      meta: {
        requireAuth: true
      },
	}, {
		path: '/order/ShareFans',
		name: '粉丝明细',
		component: OrderShareFans,
		hidden: true,
		meta: {
		  requireAuth: true
		},
	}, {
		path: '/empty',
		name: '没有账号分配',
		component: empty,
		hidden: true,
		meta: {
		  requireAuth: true
		},
	}, {
		path: '/paySuccess',
		name: '充值成功',
		component: paySuccess,
		hidden: true,
		meta: {
		  requireAuth: true
		},
	}, {
		path: '/payError',
		name: '充值失败',
		component: payError,
		hidden: true,
		meta: {
		  requireAuth: true
		},
	}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js